import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { container } from '../../../assets/material-kit-react'
import GridContainer from '../../../components/grid/GridContainer'
import GridItem from '../../../components/grid/GridItem'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from 'react-responsive-carousel'
// import Card from '../../../components/Card/Card'
import * as Sentry from '@sentry/browser'
import { Translate } from 'react-localize-redux';
Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
   });

class UnitDetail extends Component {

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
              scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
          });
          
    }

    render(){
        const { classes , images, type } = this.props

        return (
           

            <GridContainer className={classes.gridContainer}>

                <GridItem xs={12} sm={12} md={8}>
                        <Carousel width="100%"showArrows={false} showIndicators={false} showStatus={false}>
                            {
                                images.map((prop, key) => {
                                    return(
                                        <div className={classes.imageHolder}>
                                            <img 
                                                className={classes.image} 
                                                src={prop}  
                                                alt="room" 
                                                key={key}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                    </GridItem>

                    <GridItem className={classes.gridItem} xs={12} sm={12} md={4}>

                        <h3 className={classes.subtitle}>
                            { 
                                this.getRoomDescription(type)
                            }
                        </h3>

                    </GridItem>

                </GridContainer>

        )
    }


    getRoomDescription(type){

        switch (type) {
            case 0:
                return <Translate id="studio"/>
            case 1:
                return <Translate id="one_bed_room"/>
            case 2:
                return <Translate id="two_bed_room"/>
            case 3:
                return <Translate id="three_bed_room"/>
            default:
                break;
        }

    }

}


const styles = theme => ({
    container: {
        marginTop: "50px"
    },
    sections: {
        flex: 1,
        minHeight: '100vh',
        padding: '10px'
    },
    gridContainer: {
        ...container,
        padding: '10px 20px 0px 0px'
    },
    subtitle: {
        width: "375px",
        paddingLeft: "20px",
        fontFamily: '"Poppins"',
        fontSize: "13px",
        lineHeight: "1.5em",
        fontWeight: "300",
        marginLeft: "30px",
        textAlign: "justify"
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    imageHolder: {
        width: "100%",
        height: "100%",
        overFlow: "hidden"
    },
    image: {
        width: "100%",
        height: "100%",
    },
    iframe: {
        width: "80%"
    }
})


UnitDetail.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(UnitDetail)
